import dateFormatter from '../../../components/valueFormatter/dateFormatter';
import jobStatusFormatter from '../../../components/valueFormatter/jobStatusFormatter';
import jobStatusFilterValueGetter from '../../../components/filterValueGetter/jobStatusFilterValueGetter';
import updatedByFilterValueGetter from '../../../components/filterValueGetter/updatedByFilterValueGetter';
import createdByFilterValueGetter from '../../../components/filterValueGetter/createdByFilterValueGetter';
import dateFilterComparator from '../../../utils/ag-grid/dateFilterComparator';
import useUserRoles from '../../../hooks/useUserRoles';
import type { ColDef } from 'ag-grid-community';
import type { TFunction } from 'i18next';

const useColdefInventoryJob = (t: TFunction<'translation', undefined>) => {
  const { isMaintenanceadmin } = useUserRoles();
  const colDefs: ColDef[] = [
    {
      colId: 'actions',
      headerName: '',
      cellRenderer: 'actionsRenderer',
      editable: false,
      filter: false,
      pinned: 'left',
      suppressMenu: true,
      cellStyle: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      },
      minWidth: 90,
      maxWidth: 90,
      hide: !isMaintenanceadmin,
    },
    {
      field: 'id',
      headerName: t('inventory.id'),
      headerTooltip: t('inventory.id'),
      minWidth: 50,
      maxWidth: 50,
    },
    {
      field: 'firstMailDate',
      headerName: t('inventory.initialContactDate'),
      headerTooltip: t('inventory.initialContactDate'),
      filter: 'agDateColumnFilter',
      filterParams: {
        comparator: dateFilterComparator,
      },
      valueFormatter: dateFormatter,
      minWidth: 100,
      maxWidth: 100,
    },
    {
      field: 'firstMailCount',
      headerName: t('inventory.initialContactNumber'),
      headerTooltip: t('inventory.initialContactNumber'),
      filter: 'agNumberColumnFilter',
      minWidth: 105,
      maxWidth: 105,
    },
    {
      field: 'secondMailDate',
      headerName: t('inventory.secondContactDate'),
      headerTooltip: t('inventory.secondContactDate'),
      filter: 'agDateColumnFilter',
      filterParams: {
        comparator: dateFilterComparator,
      },
      valueFormatter: dateFormatter,
      minWidth: 100,
      maxWidth: 100,
    },
    {
      field: 'secondMailCount',
      headerName: t('inventory.secondContactNumber'),
      headerTooltip: t('inventory.secondContactNumber'),
      filter: 'agNumberColumnFilter',
      minWidth: 110,
      maxWidth: 110,
    },
    {
      field: 'lastDeleteDate',
      headerName: t('inventory.deletionDate'),
      headerTooltip: t('inventory.deletionDate'),
      filter: 'agDateColumnFilter',
      filterParams: {
        comparator: dateFilterComparator,
      },
      valueFormatter: dateFormatter,
      minWidth: 100,
      maxWidth: 100,
    },
    {
      field: 'lastDeleteCount',
      headerName: t('inventory.deletionNumber'),
      headerTooltip: t('inventory.deletionNumber'),
      filter: 'agNumberColumnFilter',
      minWidth: 80,
      maxWidth: 80,
    },
    {
      field: 'isActived',
      headerName: t('inventory.v_iv'),
      headerTooltip: t('inventory.v_iv'),
      cellRenderer: 'isActiveRenderer',
      // cellStyle: { textAlign: 'center' }
      minWidth: 85,
      maxWidth: 85,
    },
    {
      field: 'jobStatus',
      headerName: t('inventory.runningStatus'),
      headerTooltip: t('inventory.runningStatus'),
      valueFormatter: jobStatusFormatter,
      filterValueGetter: jobStatusFilterValueGetter,
      minWidth: 80,
      maxWidth: 80,
    },
    {
      field: 'updatedAt',
      headerName: t('grid.updatedAt'),
      headerTooltip: t('grid.updatedAt'),
      filter: 'agDateColumnFilter',
      filterParams: {
        comparator: dateFilterComparator,
      },
      valueFormatter: dateFormatter,
      minWidth: 100,
      maxWidth: 100,
    },
    {
      field: 'updatedBy',
      headerName: t('grid.updatedBy'),
      headerTooltip: t('grid.updatedBy'),
      tooltipField: 'updatedBy',
      cellRenderer: 'userNameFromEmailCellRenderer',
      filterValueGetter: updatedByFilterValueGetter,
      minWidth: 100,
    },
    {
      field: 'createdAt',
      headerName: t('grid.createdAt'),
      headerTooltip: t('grid.createdAt'),
      filter: 'agDateColumnFilter',
      filterParams: {
        comparator: dateFilterComparator,
      },
      valueFormatter: dateFormatter,
      minWidth: 100,
      maxWidth: 100,
    },
    {
      field: 'createdBy',
      headerName: t('grid.createdBy'),
      headerTooltip: t('grid.createdBy'),
      tooltipField: 'createdBy',
      cellRenderer: 'userNameFromEmailCellRenderer',
      filterValueGetter: createdByFilterValueGetter,
      minWidth: 100,
    },
  ];

  return colDefs;
};

export default useColdefInventoryJob;
